import {SuggestionsStructure} from "./suggestions-structure.model";
import {SuggestionsConfigStructure} from "../../config/suggestions/suggestions-config-structure.model";

export class SuggestionsQuery extends SuggestionsStructure {

  constructor(suggestionConfig: SuggestionsConfigStructure) {
    super(suggestionConfig);
  }
}
